import { InjectionToken } from '@angular/core';
import { DownloadDetailApiService } from './download-detail-api.service';

export const HTTP_DOWNLOAD_DETAIL_SERVICE =
  new InjectionToken<DownloadDetailApiService>('DownloadDetailApiService');

export const DOWNLOAD_DETAIL_PROVIDER = {
  provide: HTTP_DOWNLOAD_DETAIL_SERVICE,
  useClass: DownloadDetailApiService,
};
